import { createContext, useContext, useState } from 'react';

export const UserContext = createContext(undefined);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [company, setCompany] = useState();
  const [userPermission, setUserPermission] = useState();

  const value = {
    user,
    company,
    setUser,
    setCompany,
    setUserPermission,
    userPermission,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUserContext = () => {
  return useContext(UserContext);
};
